<template>
    <LayoutTreeBackground>
        <div class="grid" :class="gridClass">
            <div class="grid__elliot">
                <slot name="elliot" />
            </div><!-- __elliot -->
            <div class="grid__text">
                <slot name="text"/>
            </div><!-- __text -->

            <div class="grid__progress">
                <slot name="progress" />
            </div>
            
            <div class="grid__bottom">
                <slot name="bottom" />
            </div><!-- __bottom -->
        </div><!-- .grid -->
    </LayoutTreeBackground>
</template>

<style lang="scss" scoped>
    @import '../scss/design.scss';

    .grid {
        $_c: &;
        overflow: hidden;
        width: 100%;
        margin: 0 auto;
        flex: 1 1 auto;
        display: grid;
        grid-template-areas:    ". elliot text progress ."
                                ". bottom bottom bottom .";
        grid-template-columns: calc(50vw - #{$sound-console-max / 2}) .7fr 1fr 44px calc(50vw - #{$sound-console-max / 2});
        grid-template-rows: 57% auto;

        &.bottom-full-width {
            grid-template-areas:    ". elliot text progress ."
                                    "bottom bottom bottom bottom bottom";
        }

        &.bottom-align-end {
            #{$_c}__bottom {
                align-self: end;
            }
        }

        > * {
            z-index: 2;
        }

        &__elliot {
            grid-area: elliot;
            align-self: end;
            z-index: 0;
        }

        &__text {
            grid-area: text;
            align-self: end;
            margin-bottom: 30px;
        }

        &__progress {
            grid-area: progress;
            align-self: end;
            height: 100%;
            max-height: 330px;
            padding-left: 20px;
            padding-bottom: 30px;
        }

        &__bottom {
            grid-area: bottom;
            align-self: start;
        }
    }
</style>

<script>
import LayoutTreeBackground from './LayoutTreeBackground';
export default {
    components: {
        LayoutTreeBackground
    },
    props: {
        alignBottom: {
            type: String,
            required: false
        },
        bottomFullWidth: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        gridClass() {
            return {
                ['bottom-full-width']: this.bottomFullWidth,
                ['bottom-align-end']: this.alignBottom === 'end'
            }
        },
    }
}
</script>